// extracted by mini-css-extract-plugin
module.exports = {"list":"_93444fe79c--list--bxQz1"};